import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
//Material-UI
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
//GraphQL
import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';
//COMPONENTES EXTERNOS
import MUIRichTextEditor from 'mui-rte';
import { convertToRaw } from 'draft-js';
import { draftToMarkdown } from 'markdown-draft-js';
//DS
import { hooks } from 'lib.front';
import { validacion } from 'lib.common';
import { openMsg, loadingModal } from 'redux-app'
//ESQUEMAS
import { esquemaCampos, esquemaValidacion } from './esquemas';
const { esVarNullUndef } = validacion;
const { useValidacion } = hooks;

const useStyles = makeStyles({
   root: {
      // minWidth: 275,
   },
   bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)'
   },
   title: {
      fontSize: 14
   },
   pos: {
      marginBottom: 12
   },
   textField: {
      borderRadius: 3,
      width: '100%'
   }
});
const rteDefaultValue = {
   key: 'vacio',
   contenido: ''
};
const addTicketDetalle = gql`
   mutation AgregarTicketDetalle(
      $ticket: String!
      $descripcion: String!
      $cliente: String
      $asesor: String
      $valorizacion: Int
   ) {
      agregarTicketDetalle(
         ticket: $ticket
         descripcion: $descripcion
         cliente: $cliente
         asesor: $asesor
         valorizacion: $valorizacion
      ) {
         descripcion
      }
   }
`;
const updateTicket = gql`
   mutation ActualizarTicket($ticket: String!, $estado: Int) {
      actualizarTicket(codigo: $ticket, estado: $estado) {
         codigo
         estado
      }
   }
`;
function Mensaje({ usuario, openMsgModal, openWaitModal, data, setProcesarOK, setResponder }) {
   const classes = useStyles();
   /*
  Inicializar estados
  */
   const { campos, validacionManual, setCampo } = useValidacion(
      esquemaCampos,
      esquemaValidacion
   );

   const queryAgregar = addTicketDetalle;

   /**
    * Estados
    */
   const [ticket, setTicket] = useState(data || null);
   const [cancelar, setCancelar] = useState(false);
   const [estadoRte, setEstadoRte] = useState(rteDefaultValue);
   function toggleRte() {
      if (estadoRte.key === 'vacio') {
         setEstadoRte({
            key: 'editando',
            content: ''
         });
      } else {
         setEstadoRte(rteDefaultValue);
      }
   }

   /*
  Estados de conexion a la API
  */
   const [procesar, { loading: loadingP, error: errorP, data: dataP }] = useMutation(
    /*allowUpdate ? queryActualizar :*/ queryAgregar
   );
   const [actualizarTicket, { loading: loadingT, error: errorT, data: dataT }] = useMutation(
      updateTicket
   );

   /**
    * Funciones
    */
   /*
  Handlers
  */
   function editorChange(state) {
      const markdown = draftToMarkdown(convertToRaw(state.getCurrentContent()));
      setCampo('descripcion', markdown);
   }
   /*
  Funciones y Eventos
  */
   async function validarTodos() {
      let ok = (await validacionManual('descripcion', campos.descripcion.valor)) === '';
      return ok;
   }
   function inicializar() {
      setCampo('descripcion', '');
      toggleRte();
   }

   const procesarGrabar = async () => {
      const ok = await validarTodos();
      if (ok) {
         procesar({
            variables: {
               ticket: ticket.codigo,
               descripcion: campos.descripcion.valor,
               cliente: usuario.codigo,
               valorizacion: 0
            }
         });
      } else {
         openMsgModal('Se han encontrado errores al validar los datos.');
      }
   };

   const procesarDespuesGrabar = async () => {
      inicializar();
      setProcesarOK(true);
      handleCancelar();
   };
   const handleCancelar = () => {
      setCancelar(true);
   };

   /**
    * Efectos procesar
    */
   useEffect(() => {
      if (!esVarNullUndef(dataT)) {
         const dataAux = dataT[Object.keys(dataT)[0]];
         if (dataAux != null) {
            procesarDespuesGrabar();
         }
      }
   }, [dataT]);

   /**
    * Efectos ticketDetalle
    */
   useEffect(() => {
      if (!esVarNullUndef(dataP)) {
         if (dataP.agregarTicketDetalle != null) {
            actualizarTicket({
               variables: {
                  ticket: ticket.codigo,
                  estado: 1
               }
            });
         }
      }
   }, [dataP]);
   /**
    * Efectos Errores
    */
   useEffect(() => {
      let eMsg = '';
      if (!esVarNullUndef(errorP)) {
         eMsg = eMsg + JSON.stringify(errorP);
      }
      if (!esVarNullUndef(errorT)) {
         eMsg = eMsg + JSON.stringify(errorT);
      }
      if (eMsg !== '') {
         openMsgModal(eMsg);
      }
   }, [errorP, errorT]);

   useEffect(() => {
      openWaitModal(loadingT || loadingP);
   }, [loadingT, loadingP]);

   /**
    * Efectos
    */
   useEffect(() => {
      if (cancelar) {
         setResponder(false);
         setCancelar(false);
      }
   }, [cancelar]);

   return (
      <Card className={classes.root} variant="outlined">
         <CardContent>
            <MUIRichTextEditor
               value={estadoRte.contenido}
               onChange={editorChange}
               label="Describa su consulta"
               maxLength={200} />
         </CardContent>
         <CardActions>
            <Button variant="contained" color="primary" onClick={procesarGrabar}>
               Enviar
            </Button>
            <Button variant="contained" onClick={handleCancelar}>
               Cancelar
            </Button>
         </CardActions>
      </Card>
   );
}

function mapStateToProps(state) {
   return {
      usuario: state.auth.usuario
   };
}

function mapDispatchToProps(dispatch) {
   return {
      openMsgModal: msg => dispatch(openMsg(msg)),
      openWaitModal: loading => dispatch(loadingModal(loading))
   };
}

export default connect(mapStateToProps, mapDispatchToProps)(Mensaje);